// Lo que hace falta para que el visor prestado abra SIN salir a la red —
// ADR-2026-09-08-el-visor-abre-con-la-fila-que-el-panel-ya-tenia — compartido por la
// columna de resultados (`PanelTandaCreaciones`) y el lienzo del Agente
// (ADR-2026-09-16-el-lienzo-abre-el-visor-con-la-fila-que-ya-tiene). Nació en el panel y
// salió acá cuando el lienzo necesitó exactamente lo mismo: la misma fila y la misma
// precarga, no una segunda copia.

import type { FilaInicialVisor } from '../../GeneratedImagesHistory';
import { getCachedSignedUrl } from '../../../utils/imageCache';
import type { DatosCelda } from './useDatosDeCeldas';

/**
 * La fila con la que el visor puede abrir en el frame siguiente al toque, o `undefined`
 * si a quien la pide todavía le falta algo: los datos de la card (viajan por lote y
 * pueden no haber llegado) o la firma del original (se pide por adelantado para las
 * celdas visibles; sin ella el visor cae a su camino largo, más lento pero abre igual).
 */
export function filaInicialDeCelda(
  celda: { id: string; src: string; datos: DatosCelda | undefined },
  companyId: string | null,
): FilaInicialVisor | undefined {
  const d = celda.datos;
  if (!companyId || !d?.fileName || !d.createdAt) return undefined;
  const signedUrl = getCachedSignedUrl(`${companyId}/full/${d.fileName}`);
  if (!signedUrl) return undefined;
  return {
    id: celda.id,
    file_name: d.fileName,
    created_at: d.createdAt,
    variante_id: d.varianteId,
    variantes_ids: d.variantesIds,
    datos_generacion: d.datosGeneracion,
    // El mismo criterio que el camino largo del visor: sin producto, "Imagen".
    variante_nombre: d.varianteId ? (d.varianteNombre ?? '') : 'Imagen',
    formato: d.formato ?? '',
    tipo: d.tipo ?? '',
    favorito: d.favorito,
    upscaled_path: d.upscaledPath,
    // La miniatura que la card está dibujando: ya está decodificada en el navegador, así
    // que el visor la muestra en su primer frame y sin red.
    thumbnailUrl: celda.src,
    signedUrl,
  };
}

/**
 * Arranca la descarga del original apenas se toca la card, sin esperar a que el visor
 * monte.
 *
 * El visor hace exactamente esto (`fullPrecargada`) pero recién después de montarse, que
 * son unos cientos de ms de un componente de 7000 líneas. Pedirla acá le gana ese tramo:
 * cuando el visor la pida, ya está en la caché del navegador o a mitad de camino.
 *
 * Sólo imágenes: el `full/` de un video es el mp4 y un `Image()` no lo baja.
 */
export function precargarOriginal(url: string, esVideo: boolean): void {
  if (esVideo || !url || typeof Image === 'undefined') return;
  const img = new Image();
  img.src = url;
}
